import { request } from './client'

export type LoginRequest = {
  username: string
  password: string
}

export type LoginResponse = {
  username: string
  expires_at: string // ISO 8601
}

export type User = {
  username: string
  email: string | null
  disabled: boolean
}

/** POST /api/v1/auth/login — sets the HttpOnly session cookie */
export async function login(payload: LoginRequest): Promise<LoginResponse> {
  return request<LoginResponse>('/v1/auth/login', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

/** POST /api/v1/auth/logout — auth-gated; clears the session cookie */
export async function logout(): Promise<void> {
  await request<{ logged_out: boolean }>('/v1/auth/logout', {
    method: 'POST',
  })
}

/** GET /api/v1/auth/me — auth-gated; returns the current user. Throws ApiError(401) when no/invalid session. */
export async function getCurrentUser(): Promise<User> {
  return request<User>('/v1/auth/me')
}
